<h1 mat-dialog-title>{{ 'createSubjectDialog.title' | translate }}</h1>
<button mat-icon-button (click)="cancel()" mat-dialog-close>
  <mat-icon>close</mat-icon>
</button>
<div mat-dialog-content>
  <div *ngIf="labRestriction">
    {{ 'createSubjectDialog.labels.labRestrictionWarning' | translate }}
  </div>
  <div *ngIf="groups.length === 0 && !labRestriction ">
    {{ 'createSubjectDialog.labels.noProjectsWarning' | translate }}
  </div>
  <form
    *ngIf="groups.length > 0 && !labRestriction"
    class="form-full-width"
    [formGroup]="form">
    <label [id]="getLabelId('project-select')">{{ 'common.labels.project' | translate }}<span class="red">*</span></label>
    <mat-form-field appearance="outline">
      <mat-select
        formControlName="projectSelect"
        [aria-labelledby]="getLabelId('project-select')"
        [placeholder]="'createSubjectDialog.labels.selectProject' | translate">
        <mat-optgroup *ngFor="let group of groups" [label]="group.label">
          <mat-option *ngFor="let project of group.projects" [value]="project._id">
            {{ project.label }}
          </mat-option>
        </mat-optgroup>
      </mat-select>
      <mat-error *ngIf="form.get('projectSelect').hasError('required')">{{ 'createSubjectDialog.labels.fieldRequired' | translate }}</mat-error>
    </mat-form-field>    

    <label [id]="getLabelId('subject-label')">{{ 'createSubjectDialog.labels.subjectLabel' | translate }}<span class="red">*</span></label>
    <mat-form-field appearance="outline">
      <input
        matInput
        test-id="subject-label"
        [id]="getLabelId('subject-label')"
        [attr.aria-labelledby]="getLabelId('subject-label')"
        [placeholder]="'createSubjectDialog.labels.subjectLabel' | translate"
        type="text"
        formControlName="subjectLabel"
        autocomplete="off">
      <mat-error *ngIf="form.get('subjectLabel').hasError('maxlength')">{{ 'common.errors.maxLength' | translate }}</mat-error>
      <mat-error *ngIf="form.get('subjectLabel').hasError('minlength')">{{ 'common.errors.minLength' | translate }}</mat-error>
      <mat-error *ngIf="form.get('subjectLabel').hasError('required')">{{ 'createSubjectDialog.labels.fieldRequired' | translate }}</mat-error>
    </mat-form-field>
  </form>
</div>
<div mat-dialog-actions align="end">
  <button mat-dialog-close mat-stroked-button (click)="cancel()" test-id="close-button">{{ 'common.actions.close' | translate }}</button>
  <button mat-flat-button [disabled]="form.invalid" test-id="save-button" color="primary" (click)="submit()">
    {{ 'common.actions.save' | translate }}
  </button>
</div>
